import {AfterViewInit, Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ToastModule} from 'primeng/toast';
import {BufferedMessageService} from '@shared/services/buffered-message.service';
import { VersionInfoComponent } from './layout/components/version/version-info.component';

@Component({
  selector: 'pek-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    ToastModule,
    VersionInfoComponent,
  ],
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  private readonly bufferedMessageService = inject(BufferedMessageService);

  ngAfterViewInit(): void {
    this.bufferedMessageService.markReady();
  }
}
